module.exports = __webpack_public_path__ + "media/images/neuro_assestment-aec5ee897c62daa622135171072c7595.png";